import React, { useState, useEffect } from "react";
import plusWhite from "../../../assets/images/plus-white.svg";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import "../../../styles/style.css";
import "../../../styles/payout.css";
import "../../../styles/upi-mandate.css";
import trashIcon from "../../../assets/images/trash-03.svg";
import editIcon from "../../../assets/images/edit_btn.svg";
import Pagination from "../../../components/pagination/paginationView";
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import { Loader } from "../../../components/loader";
import { deleteFreeModule, getFreeContestList } from "../../../action/contest";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { SingleErrorMessage } from "../../singleErrorMessage";
import { Modal } from "react-bootstrap";
import showNotification from "../../../components/notification/showNotification";
const FreeContest = () => {
  const { pagenumber } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [categoryList, setCategoryList] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [pageNo, setPageNo] = useState(
    location.state || Number(pagenumber) || 1
  );
  const [totalData, setTotalData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [startStatusLoading, setStartStatusLoading] = useState(false);
  const [moduleId, setModuleId] = useState("");
  const [curId, setCurId] = useState("");
  const [deleteModel, setDeleteModel] = useState(false);
  const getCategoryPage = async (page) => {
    try {
      setIsLoading(true);
      const response = await getFreeContestList(page, pageSize); // Adjust 10 to the desired number of items per page
      if (response.status) {
        setCategoryList(response.data.details);
        setTotalData(response.data.count);
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Failed to fetch category data", error);
    }
  };

  const deleteModuledata = async () => {
    const response = await deleteFreeModule(moduleId);
    if (response.status) {
      showNotification("Success", "Question deleted Successfully!", "success");
      setDeleteModel(false);
      getCategoryPage(pageNo);
    } else {
      showNotification("Error", response.message, "danger");
    }
  };
  useEffect(() => {
    getCategoryPage(pageNo);
  }, [pageNo, pageSize]);

  return (
    <div className="payout_data-content">
      <div className="payout_data-head">
        <div className="payout_data-head-top mb-2">
          <div className="payout_data-left">
            <div className="payout_data_ttl">
              {" "}
              <Breadcrumb paths={[{ name: "Question Library" }]} />
            </div>
          </div>
          <Link
            className="btn btn-info addbbtn"
            color="info"
            to={"/contest/free-contest/add"}
            state={location.state}>
            Add Question
            <img
              src={plusWhite}
              alt=""
              className="payout_down"
            />
          </Link>
        </div>
      </div>

      <div className="payout_inner_content">
        <table className="payout_table upi-mandate_table">
          <thead>
            <tr className="tableHead">
              <th className="thHeader">
                <div className="payoutHead hndIcon">Title</div>
              </th>
              <th className="thHeader">
                <div className="payoutHead hndIcon">Category</div>
              </th>
              <th className="thHeader">
                <div className="payoutHead hndIcon">Options</div>
              </th>

              <th className="thHeader">
                <div className="payoutHead hndIcon">Action</div>
              </th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan="15">
                  <Loader />
                </td>
              </tr>
            ) : (
              <>
                {categoryList?.length > 0 ? (
                  categoryList?.map((item) => (
                    <tr key={item._id}>
                      <td>{item?.title?.en}</td>
                      <td>{item?.moduleCategoryId?.name}</td>
                      <td>{item?.options?.length}</td>
                      <td className="three_btn">
                        <Link
                          to={`/free-contest/edit/${item._id}`}
                          state={pageNo}>
                          <img
                            src={editIcon}
                            alt="Edit icon"
                          />
                        </Link>

                        <Link
                          className="dlt_btn"
                          onClick={(e) => {
                            e.preventDefault();
                            setDeleteModel(true);
                            setModuleId(item._id);
                          }}>
                          <img
                            src={trashIcon}
                            style={{
                              height: "26px",
                            }}
                            alt="delete icon"
                          />
                        </Link>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="15"
                      className="text_center">
                      No data available
                    </td>
                  </tr>
                )}
              </>
            )}
          </tbody>
        </table>
      </div>
      {categoryList.length > 0 && (
        <>
          <Pagination
            currentPage={pageNo}
            totalCount={totalData}
            pageSize={pageSize}
            onPageChange={(page) => setPageNo(page)}
            changePageSize={(page) => {
              setPageSize(page);
              setPageNo(1);
            }}
          />
        </>
      )}
      <Modal
        show={deleteModel}
        onHide={() => {
          setDeleteModel(false);
        }}>
        <Modal.Header closeButton>
          <Modal.Title>Delete the question</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this question?</Modal.Body>
        <Modal.Footer>
          <button
            variant="secondary"
            className="btn btn-dark"
            onClick={() => {
              setDeleteModel(false);
            }}>
            No
          </button>
          <button
            className="btn btn-success"
            variant="primary"
            onClick={() => {
              deleteModuledata();
            }}>
            Yes
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default FreeContest;
